import React from 'react';
import { API_URL } from '../../../../constants/ApplicationUrl'
import { Link } from 'react-router-dom';
import moment from 'moment';
import { getDocumentLink } from '../../../../dependencies/utils/helper'
import { ROLES } from '../../../../constants/Roles';
import { storage } from '../../../../dependencies/store/storage';

const columns = (
  {
    clickOnAction,
    pageNo,
    size
  }
) => {
  const userRole = storage.getUserRole();

  return [
    {
      dataField: '',
      text: 'S.No',
      formatter: (cell, row, rowIndex) => {
        return (pageNo * size) + (rowIndex + 1);
      }
    }, {
      dataField: 'title',
      text: 'Notification Title',

    }, {
      dataField: '',
      text: 'Document / Link',
      formatter: (cell, row) => {

        const url = row && row.fileInfo && row.fileInfo.publicUrl || '';
        const link = row && row.url || "";
        return (
          <div className="IAS-Actions-list">
            {url && <a href={getDocumentLink(url)} target="_blank">View Documents</a>}
            {link ? <div><a href={`${link}`} target="_blank">View link</a></div> : null}
          </div>
        )
      }

    }, {
      dataField: 'linkTitle',
      text: 'Link Title',
    }, {
      dataField: 'action',
      text: 'Action',
      hidden: userRole !== ROLES.SUPER_ADMIN && userRole !== ROLES.ADMIN,
      formatter: (cell, row) => {
        const { id } = row;
        return (
          <div className="IAS-Actions-list">
            <span><a href='javascript:void(0)' onClick={() => clickOnAction(id)}>Delete</a></span>
            <span className='edit-color'><Link to={`/notification/form/${id}`} >Edit</Link></span>
          </div>
        )

      }
    }
  ];
}

export default columns;